import GavelIcon from '@mui/icons-material/Gavel';
import { ContentPageLayout } from 'root/src/client/v2/_pages/content/redesign/ContentPageLayout';
// Legal page chrome. Thin wrapper over the shared `ContentPageLayout` that pins the Gavel header icon
// and maps `effectiveDate` to the generic subtitle slot. Kept as its own component so the three legal
// pages read clearly; the layout itself is shared (DRY) with FAQ.
export const LegalPageLayout = ({ title, effectiveDate, tableOfContents, children }) => (<ContentPageLayout icon={GavelIcon} title={title} subtitle={effectiveDate} tableOfContents={tableOfContents}>
		{children}
	</ContentPageLayout>);
